module.exports = __webpack_public_path__ + "static/media/icone_logo.f36dd7eb.svg";